import React from 'react';
import { Helmet } from 'react-helmet';


function Contact_Us_Seo() {
    return (
        <div>
            <Helmet>
                <title>Contact Us | FinestPay</title>
                <meta name="description" content="Call us on +44 785 253 8754 or email us at info@finestpay.co.uk We would like to answer any questions you got regarding sending money to Nigeria. Contact us today." />
                <meta property="og:title" content="Contact Us | FinestPay" />
                <meta property="og:description" content="Call us on +44 785 253 8754 or email us at info@finestpay.co.uk We would like to answer any questions you got regarding sending money to Nigeria. Contact us today." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png"/>
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/contact-us"/>
            </Helmet>
        </div>
    )
}

export default Contact_Us_Seo
